enum TrafficChangesPeriod {
    MonthOverMonth = "mom",
    QuoterOverQuoter = "qoq",
    YearOverYear = "yoy",
}

export default TrafficChangesPeriod;
